import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    inactivo: false,
    rowVersion: null,
    
    bienRubroDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, bienRubroId) {
        state.id = bienRubroId;
        state.nombre = '';
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_BIEN_RUBRO'(state, bienRubro) {
        state.nombre = bienRubro.nombre.toUpperCase().trim();
        state.inactivo = bienRubro.inactivo;
        state.rowVersion = bienRubro.rowVersion;
    },
    'SET_BIEN_RUBRO_ID'(state, params) {
        state.id = params.id;
        state.rowVersion = params.rowVersion;
    },

    'INICIALIZAR_DATOS'(state) {
        state.bienRubroDatos = [];
    },
    'SET_DATOS'(state, bienRubroDatos) {
        state.bienRubroDatos = bienRubroDatos;
    },
};

const getters = {
    getField,

    bienRubro(state) {
        return {
            id: state.id,
            nombre: state.nombre.toUpperCase().trim(),
            inactivo: state.inactivo,
            rowVersion: state.rowVersion,
        }
    }
};

const actions = {
    inicializar ( { commit }, bienRubroId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', bienRubroId);
            if (bienRubroId != 0){
                apiAxios.get(`bienes/rubros/${bienRubroId}/abm`) 
                    .then(res => {
                        commit('SET_BIEN_RUBRO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },    
    save ( {commit} ) {
        return new Promise((resolve, reject) => {
            let bienRubro= {
                nombre: state.nombre.toUpperCase().trim(),
                inactivo: state.inactivo,
            }

            let url = 'bienes/rubros';
            if (state.id != 0) {
                url += '/' + state.id;
                bienRubro.rowVersion = state.rowVersion
            }

            apiAxios.post(url, bienRubro)
                .then((res) => {
                    /* Actualizamos Id y RowVersion */
                    commit('SET_BIEN_RUBRO_ID', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getDatos ( { commit }, bienRubroId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (bienRubroId != 0) {
                apiAxios.get(`bienes/rubros/${bienRubroId}`) 
                    .then(res => {
                        let datos = [
                            { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': res.data.inactivo? 'Si' : 'No', 'formato': '' },
                        ];
                        commit('SET_DATOS', datos);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}